<template>
    <article class="article-wrapper article5 fade13"
    :class="{'active': $parent.isfadeInActive && $parent.isfadeInA5}">
        <audio src="@/assets/audio/section5_h.mp3" type="audio/mpeg"
        ref="hoverMusic" preload></audio>
        <audio src="@/assets/audio/sign.mp3" type="audio/mpeg"
        ref="signMusic" preload></audio>
        <div id="poems" class="frame-wrapper" :class="{
            'frame-bg1':targetIdx===0,
            'frame-bg2':targetIdx===1,
            'frame-bg3':targetIdx===2}">
            <div class="photo-wrapper cursor-pointer fade13"
            :class="{'active': $parent.isfadeInActive && $parent.isfadeInA5}"
            v-on:click.prevent="popup();gaEvent('play_btn', 'luck_play');"
            v-on:mouseenter="toggleHoverMusic(true)"
            v-on:mouseleave="toggleHoverMusic(false)">
                <template v-if="targetIdx===1">
                    <img src="@/assets/images/article5/img_article5_item_1_v2@2x.png"
                    class="photo photo1 article5Photo"/>
                    <img src="@/assets/images/article5/img_article5_item_2_v2@2x.png"
                    class="photo photo2 article5Photo"/>
                </template>
                <template v-else-if="targetIdx===2">
                    <img src="@/assets/images/article5/img_article5_item_1_v3.png"
                    v-show="!isHover"
                    class="photo photo3 article5Photo"/>
                    <img src="@/assets/images/article5/img_article5_item_v3_hover.png"
                    v-show="isHover"
                    class="photo photo3 article5Photo"/>
                    <!-- <img src="@/assets/images/article5/img_article5_item_2_v2@2x.png"
                    class="photo photo2 article5Photo"/> -->
                </template>
                <template v-else>
                    <img src="@/assets/images/article5/img_article5_item_1@2x.png"
                    class="photo photo1 article5Photo"/>
                    <img src="@/assets/images/article5/img_article5_item_2@2x.png"
                    class="photo photo2 article5Photo"/>
                </template>
                <span
                class="throw-btn" title="點擊擲筊求運勢"
                :class="{
                    'throw-bg3':targetIdx===2
                }">
                </span>
            </div>
            <div class="text-wrapper" :class="{
                'text-bg1':targetIdx===0,
                'text-bg2':targetIdx===1,
                'text-bg3':targetIdx===2}">
                <h1 class="title fade13"
                :class="{'active': $parent.isfadeInActive && $parent.isfadeInA5}"
                v-html="data.title">莘莘學子齊擲筊，<wbr>人生順利國泰民安</h1>
                <div class="info-wrapper fade14"
                :class="{'active': $parent.isfadeInActive && $parent.isfadeInA5}">
                    <p class="source">
                        【發布單位／{{data.title_unit}}】
                        <a href="" title="FB分享" class="fb-btn"
                        @click.prevent="onShare('fb', data.share_link);
                        gaEvent('share_fb', 'luck_sharefb');">
                            <img src="@/assets/images/btn_article_fb_n@3x.png" />
                        </a>
                        <a href="" title="Line分享" class="line-btn"
                        @click.prevent="onShare('line', data.share_link_line, data.line_text);
                        gaEvent('share_line', 'luck_shareline');">
                            <img src="@/assets/images/btn_article_line_n@3x.png" />
                        </a>
                    </p>
                </div>
                <p class="description fade15" v-html="data.content"
                :class="{'active': $parent.isfadeInActive && $parent.isfadeInA5}">
                    吉凶禍福，吉人自有天相。鑑於全球局勢動盪，福利社特邀同學線上擲筊，此筊有神力，
                    籤詩首首中紅心，沒事擲擲，保佑同學時時靈光亮，大事化小，小事化無，危機變轉機，世界自然放光明，在此祝福各位同學自愛而平凡的活著。
                </p>
            </div>
        </div>
        <Sign
        :show="isOpen" :isPc="isPc" :poems="poems"
        :targetPoemId="targetPoemId" :targetIdx="targetIdx"/>
    </article>
</template>

<script>
import Sign from '@/components/Sign.vue';
import mixinMethod from '@/js/mixin/mixinMethod';


export default {
    name: 'poems5',
    props: {
        data: {
            type: Object,
            default() {
                return {
                    title: '',
                    title_unit: '',
                    content: '',
                    share_link: '',
                };
            },
        },
        poems: {
            type: Array,
            default() {
                return [
                    {
                        image_path: '',
                        share_link: '',
                    },
                ];
            },
        },
        isPc: {
            type: Boolean,
        },
        targetPoemId: {
            type: Number,
            default: 0,
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            gaCategory: '',
            isOpen: false,
            isPlay: false,
            isHover: false,
        };
    },
    mounted() {
    },
    methods: {
        popup() {
            this.isOpen = !this.isOpen;
            if (!this.isPc) {
                this.$store.commit('toggleDivination', this.isOpen);
            }
            this.$parent.toggleNav(!this.isOpen);
            if (this.isOpen) {
                window.setTimeout(() => {
                    this.triggerSignMusic();
                }, 1600);
            }
        },
        onShare(kind, url) {
            this.$parent.onShare(kind, url);
        },
        triggerSignMusic() {
            this.playAudio('signMusic');
        },
        toggleHoverMusic(isPlay) {
            this.playAudio('hoverMusic', !isPlay);
            this.isHover = isPlay;
        },
    },
    mixins: [mixinMethod],
    components: {
        Sign,
    },
};
</script>
